import MyLoanModel from '../models/school-loans.model';
import Product from '../models/product.model';

let storeContent = utils.generateStore({
	MyLoanModel,
	loan_transactions: [],
	my_loans: [],
	selected_loan: null,
	loan_acc_num: null,
	loan_details: null,
	showViewLoan: false,
	activeTabLoan: 1,
	my_loan_details_table: [],
	loan_notifications: [],
	loan_payment_schedules: [],
	Product,
});

export default {
	state() {
		return { ...storeContent.state };
	},
	getters: {
		...storeContent.getters,
	},
	mutations: {
		...storeContent.mutations,
	},
	actions: {
		openTabLoan(ctx, page) {
			ctx.commit('activeTabLoan', page);
		},
		async fetchLoans(ctx) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'loan',
						action: 'loans',
						data: {},
					},
					'/client',
				);

				if (res.result.client_loan_accounts) {
					ctx.commit('my_loans', res.result.client_loan_accounts);
				}
			} catch (err) {
				throw err;
			}
		},
		async submitReview(ctx, payload) {
			try {
				ctx.commit('loading', true);
				let data = payload.ref.formData_;

				if (await payload.ref.isValid()) {
					let res = await api.fetchEndpointSecure(
						{
							resource: 'loan_account',
							action: 'create_review',
							data: {
								loan_account_number: ctx.getters.loan_acc_num,
								rating: data.rating,
								review: data.review,
							},
						},
						'/client',
					);

					ctx.commit('showAddReviews', false);
					$notify(
						'success',
						'Review Submitted',
						`Your review has been successfully submitted`,
						10,
					);
				}
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
			ctx.commit('loading', false);
		},
		async fetchMyLoanReviews(ctx) {
			try {
				Event.$emit('loader:show', true);

				let res = await api.fetchEndpointSecure(
					{
						resource: 'loan_account',
						action: 'list_reviews',
						data: {
							loan_account_number: ctx.getters.loan_acc_num,
						},
					},
					'/client',
				);

				ctx.commit('product_reviews', res.result.loan_act_reviews);

				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		async fetchLoanDetailsTable(ctx) {
			try {
				// let res = await api.fetchEndpointSecure(
				//   {
				//     resource: 'ipf_product',
				//     action: 'loan_account_details',
				//     data: {
				//       account_number: ctx.getters.ipf.ipf_details.ipf_loan_account,
				//     },
				//   },
				//   '/client'
				// );

				ctx.commit('my_loan_details_table', [
					{
						title: 'Principle',
						original: 1000,
						paid: 300,
						written_off: 20,
						overdue: 100,
						outstanding: 680,
					},
					{
						title: 'Interest',
						original: 1000,
						paid: 300,
						written_off: 20,
						overdue: 100,
						outstanding: 680,
					},
					{
						title: 'Charges',
						original: 1000,
						paid: 300,
						written_off: 20,
						overdue: 100,
						outstanding: 680,
					},
					{
						title: 'Total',
						original: 1000,
						paid: 300,
						written_off: 20,
						overdue: 100,
						outstanding: 680,
					},
				]);
			} catch (err) {
				throw err;
			}
		},
		async payLoan(ctx, payload) {
			try {
				ctx.commit('loading', true);

				if (await payload.ref.isValid()) {
					let res = await api.fetchEndpointSecure(
						{
							resource: 'loan',
							action: 'payment',
							data: {
								account_number: ctx.getters.loan_acc_num,
								amount: payload.ref.formData_.amount,
								payment_type: payload.ref.formData_.amount,
								remarks: payload.ref.formData_.remarks,
							},
						},
						'/client',
					);

					payload.ref.resetForms();
					await ctx.dispatch('fetchLoans');
					ctx.commit('showViewLoan', false);
					$notify(
						'success',
						`Loan Payment Success - ${res.result.transaction_ref}`,
						`Loan repayment of ${payload.ref.formData_.amount} paid`,
					);
				}

				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async fetchLoanDetails(ctx, loan) {
			try {
				ctx.commit('loan_acc_num', loan.account_number);
				let res = await api.fetchEndpointSecure(
					{
						resource: 'loan',
						action: 'details',
						data: {
							account_number: loan.account_number,
						},
					},
					'/client',
				);

				ctx.commit('loan_details', res.result);

				ctx.commit('loan_notifications', [
					{
						created_at: '2021-06-01T18:59:30.712Z',
						subject: 'Loan Payment',
						notification:
							'Loan payment was made on <b>6th Aug 2021</b>. Amount Paid was <b>KES 12,000</b>.',
					},
					{
						created_at: '2021-06-01T18:59:30.712Z',
						subject: 'Loan Payment',
						notification:
							'Loan payment was made on <b>6th Aug 2021</b>. Amount Paid was <b>KES 12,000</b>.',
					},
					{
						created_at: '2021-06-01T18:59:30.712Z',
						subject: 'Loan Payment',
						notification:
							'Loan payment was made on <b>6th Aug 2021</b>. Amount Paid was <b>KES 12,000</b>.',
					},
					{
						created_at: '2021-06-01T18:59:30.712Z',
						subject: 'Loan Payment',
						notification:
							'Loan payment was made on <b>6th Aug 2021</b>. Amount Paid was <b>KES 12,000</b>.',
					},
				]);

				ctx.commit('loan_transactions', res.result.loan_transactions);

				ctx.commit(
					'loan_payment_schedules',
					res.result.payment_schedules,
				);
			} catch (err) {
				throw err;
			}
		},
		async viewLoan(ctx, loan) {
			try {
				Event.$emit('loader:show', true);
				await ctx.commit('selected_loan', loan);
				await ctx.dispatch('fetchLoanDetailsTable');
				await ctx.dispatch('fetchLoanDetails', loan);
				await ctx.commit('showViewLoan', true);
				Event.$emit('loader:show', false);

				// Pre load normal on payment form
				let model = ctx.getters.MyLoanModel;
				model.forms.loans_pay.data.payment_option = 'normal';
				ctx.commit('MyLoanModel', model);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		async fetchData(ctx) {
			try {
				Event.$emit('loader:show', true);
				await ctx.dispatch('fetchLoans');
				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
	},
};
